import { go } from 'oderon-vue'

export const Tracker = {
  findStats(qs) {
    return go.get(`/tracker/stats`, qs)
  },
  findCondensed(syntheticVid, qs) {
    return go.get(`/tracker/positions/${syntheticVid}`, qs)
  },
  findAggregate(syntheticVid, qs) {
    return go.get(`/tracker/aggregate/${syntheticVid}`, qs)
  }
}
